module.exports = "pegasus/assets/email1-img11.png";